<template>
  <div class="modal-card" style="width: 650px">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage User</p>
      <div class="columns">
        <div class="column">
          <div>
            <b-switch type="is-success" v-model="user.active"></b-switch>
          </div>
        </div>
      </div>
    </header>
    <section class="modal-card-body">
      <!--   //////////////////////////////////////////////////////// -->
      <div class="card-content">
        <div class="columns">
          <div class="column">
            <b-field label="Name">
              <b-input
                type="text"
                v-model="user.name"
                placeholder="e.g. Viral Patel"
                required
              >
              </b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Email">
              <b-input
                type="text"
                v-model="user.email"
                placeholder="e.g. itm@itm.edu"
                required
              >
              </b-input>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Mobile No.">
              <b-input
                type="text"
                v-model="user.mobile"
                placeholder="e.g. +91 8155950590"
              >
              </b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field label="Role">
              <b-select
                v-model="user.role"
                placeholder="Select a Role"
                expanded
              >
                <option value="candidate">Candidate</option>
                <option value="admin">Admin</option>
              </b-select>
            </b-field>
          </div>
          <!-- <div class="column">
                            <b-field label="Password">
                                <b-input type="text" v-model="user.password" placeholder="e.g. itm@123" required>
                                </b-input>
                            </b-field>
                        </div> -->
        </div>
        <div class="columns">
          <div class="column is-6">
            <b-field label="Premium 👑">
              <b-switch type="is-success" v-model="user.premium"></b-switch>
            </b-field>
          </div>
        </div>
      </div>
      <!-- /////////////////////////////////////////////// -->
    </section>
    <footer class="modal-card-foot">
      <button
        class="button is-black full-width-button"
        style="width: 100%; color: white"
        :class="{ 'is-loading': isLoading }"
        @click="manageUser(user)"
      >
        Save
      </button>
    </footer>
  </div>
</template>

<script>
import UserService from "./service";
import UploadService from "../../lib/UploadService";
/* import GroupService from '../settings/service' */
import Firebase from "../../lib/Firebase";
import Firestore from "../../lib/Firestore";
export default {
  name: "addUser",
  props: ["propUser"],

  created() {
    /* this.fetchGroups(); */

    if (this.propUser.docId) {
      this.user = {
        ...this.propUser,
      };
    }
  },

  data() {
    return {
      isLoading: false,
      user: {
        location: "",
        mobile: 0,
        businessUnits: [],
        ledgers: [],
        active: false,
      },
      mobile: null,
      priceList: {},
      test: "",
      selected: null,
      selected1: null,
      selectedBU: null,
      ledgerList: [],
      selectedLedger: null,
    };
  },

  methods: {
    uploadImage() {
      UploadService(this.files[0], "users", user.docId)
        .then(() => {
          this.isLoading = false;
          this.$buefy.toast.open("Image saved successfully");
        })
        .catch(() => {
          this.isLoading = false;
          this.$buefy.toast.open("Error saving image");
        });
    },
    addItemToPriceList(selectedBU) {
      if (!this.user.businessUnits) {
        this.user.businessUnits = [];
      }
      this.user.businessUnits.push(selectedBU);
    },
    removeItemFromPriceList(index) {
      this.user.businessUnits.splice(index, 1);
    },
    addLedgers(ledger) {
      if (!this.user.ledgers) {
        this.user.ledgers = [];
      }
      this.user.ledgers.push(ledger);
    },
    removeLedger(index) {
      this.user.ledgers.splice(index, 1);
    },
    manageUser(user) {
      this.isLoading = true;
      this.aemail = user.email;
      this.apass = user.password;
      //    this.db = this.user1

      if (!this.propUser) {
        Firebase.auth()
          .createUserWithEmailAndPassword(this.aemail, this.apass)
          .then(function (vv) {
            console.log(user);
            console.log(vv.user.uid);
            return Firebase.firestore()
              .collection("users")
              .doc(vv.user.uid)
              .set({
                email: user.email,

                mobile: user.mobile,
                name: user.name,
                password: user.password,
                role: user.role,

                active: user.active,
              });
          })
          .then(() => {
            this.$buefy.toast.open({
              message: "User Created!",
              position: "is-top",
              type: "is-success",
            });

            this.$emit("close");
          })
          .catch(function (error) {
            this.$buefy.toast.open({
              message: "Error creating user!",
              position: "is-top",
              type: "is-danger",
            });
            console.log("Error creating user:", error);
          });
      } else {
        this.isLoading = false;
        console.log(user);
        console.log(this.propUser.docId);
        Firebase.firestore()
          .collection("users")
          .doc(this.propUser.docId)
          .update(user);
        this.$buefy.toast.open({
          message: "User updated!",
          position: "is-top",
          type: "is-success",
        });
        this.$emit("close");
      }

      /*    SettingsService.manageUser(this.user1, this.uid).then(newUser => {
          this.$buefy.toast.open('User Updated successfull');
          location.reload();
        });     */
    },
    /* manageUser() {
            this.isLoading = true;

            UserService.manageUser(this.user).then(
                newUser => {
                    this.isLoading = false;
                    const isNewUser = !this.user.docId;
                    const userObj = {
                        ...this.user
                    };

                    if (isNewUser) {
                        userObj.docId = newUser.id;
                    }

                   
                    Firebase.auth().createUserWithEmailAndPassword(this.user.email, this.user.password)
                        .then(response => {
                            this.$buefy.toast.open('User Created successfull ${response}');
                        })
                        .catch(err => {
                            console.log(err);
                        });

                    this.$bus.$emit('QURY_UPDATE', userObj, isNewUser);
                    this.$emit('close');
                    this.$buefy.toast.open('User Updated successfull');
                    console.log(test);
                    console.log(test1)
                }
            );
        }, */
  },
  /* computed: {
            filteredDataArray() {
          
                 return this.data.filter((option) => {
                     return option
                         .toString()
                         .toLowerCase()
                         .indexOf(this.user.state.toLowerCase()) >= 0
                 })
             },
             filteredDataArraychapter() {
          
                 return this.districts.filter((option) => {
                     return option
                         .toString()
                         .toLowerCase()
                         .indexOf(this.user.chapter.toLowerCase()) >= 0
                 })
             }

         } */
};
</script>

<style>
.zipcode-container {
  display: flex;
  justify-content: space-between;
}

.pan-image {
  height: 270px;
}
</style>


// WEBPACK FOOTER //
// src/pages/users/AddUser.vue